import axios from 'axios';
import { formatDateOnly } from '../components/Utils';

export const designerBookingsPath = (calendar, designer, weekStart) => {
  const date = weekStart ? formatDateOnly(weekStart) : null;
  let paramsPart = date ? `?date=${date}` : '';
  paramsPart = designer && designer.id ? `${paramsPart}&designer_id=${designer.id}` : paramsPart;
  return `/design/calendars/${calendar.id}/bookings${paramsPart}`;
};

export const upcomingDesignerBookingsPath = (calendar, designer, weekStart, page) => {
  const date = weekStart ? formatDateOnly(weekStart) : null;
  let paramsPart = `?date=${date}&page=${page}`;
  paramsPart = designer && designer.id ? `${paramsPart}&designer_id=${designer.id}` : paramsPart;
  return `/design/calendars/${calendar.id}/bookings${paramsPart}`;
};

export const loadBookings = (calendar, designer, weekStart, onSuccess, onError) => {
  const data = {};
  axios
    .get(designerBookingsPath(calendar, designer, weekStart), data)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};
export const loadUpcomingBookings = (calendar, designer, weekStart, page, onSuccess, onError) => {
  const data = {};
  axios
    .get(upcomingDesignerBookingsPath(calendar, designer, weekStart, page), data)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/api/BookingsApi.js